import React, { useState, useEffect, useRef, useContext } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { head } from "lodash";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { i18n } from "../../translate/i18n";
import moment from "moment";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography
} from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import ConfirmationModal from "../ConfirmationModal";
import { Autocomplete, Checkbox, Chip, Stack } from "@mui/material";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
    },
  },
  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  btnWrapper: {
    position: "relative"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  dialogTitle: {
    textAlign: "center",
    padding: theme.spacing(3),
    color: theme.palette.type === 'dark' ? "white" : "#6517ab",
    "& h2": {
      fontWeight: 800,
      fontSize: "1.5rem",
    }
  },
  dialogContent: {
    padding: theme.spacing(3, 5),
  },
  dialogActions: {
    padding: theme.spacing(3, 5),
    justifyContent: "flex-end",
    gap: theme.spacing(2),
  },
  checkbox: {
    color: "#6517ab !important",
  },
  online: {
    color: "#10b981",
    fontWeight: "bold",
    margin: 0,
    marginLeft: "5px",
  },
  offline: {
    color: "#ef4444",
    fontWeight: "bold",
    margin: 0,
    marginLeft: "5px",
  },
  saveButton: {
    background: "linear-gradient(45deg, #6517ab 30%, #8e44ad 90%)",
    color: "white",
    borderRadius: "12px",
    padding: "10px 30px",
    fontWeight: "bold",
    textTransform: "none",
    boxShadow: "0 4px 15px rgba(101, 23, 171, 0.3)",
    "&:hover": {
      background: "linear-gradient(45deg, #5a1499 30%, #7d3ca3 90%)",
      transform: "translateY(-1px)",
    },
  },
  cancelButton: {
    borderRadius: "12px",
    padding: "10px 30px",
    fontWeight: "bold",
    textTransform: "none",
    color: theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.6)",
    border: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)"}`,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
}));

const CampaignModalPhrase = ({ open, onClose, FlowCampaignId, onSave }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMounted = useRef(true);
  const { user } = useContext(AuthContext);
  const { companyId } = user;

  const [campaignEditable, setCampaignEditable] = useState(true);
  const attachmentFile = useRef(null);

  const [dataItem, setDataItem] = useState({
    name: "",
    phrase: ""
  });

  const [dataItemError, setDataItemError] = useState({
    name: false,
    flowId: false,
    phrase: false
  });

  const [flowSelected, setFlowSelected] = useState();
  const [flowsData, setFlowsData] = useState([]);
  const [flowsDataComplete, setFlowsDataComplete] = useState([]);

  const [selectedWhatsapp, setSelectedWhatsapp] = useState("")
  const [whatsAppNames, setWhatsAppNames] = useState([])
  const [whatsApps, setWhatsApps] = useState([])
  const [whatsAppSelected, setWhatsAppSelected] = useState({})

  const [active, setActive] = useState(true)

  const [loading, setLoading] = useState(true);

  const getFlows = async () => {
    const flows = await api.get("/flowbuilder");
    setFlowsDataComplete(flows.data.flows);
    setFlowsData(flows.data.flows.map(flow => flow.name));
    return flows.data.flows;
  };

  const detailsPhrase = async flows => {
    setLoading(true);
    await api.get(`/flowcampaign/${FlowCampaignId}`).then(res => {
      console.log("dete", res.data);
      setDataItem({
        name: res.data.details.name,
        phrase: res.data.details.phrase
      });
      setActive(res.data.details.status)
      const nameFlow = flows.filter(
        itemFlows => itemFlows.id === res.data.details.flowId
      );
      if (nameFlow.length > 0) {
        setFlowSelected(nameFlow[0].name);
      }
      setLoading(false);
    });
  };

  const handleClose = () => {
    onClose();
  };

  const openModal = async () => {
    const flows = await getFlows();
    if (FlowCampaignId) {
      await detailsPhrase(flows);
    } else {
      clearData();
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true)
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        api
          .get(`/whatsapp`, { params: { companyId, session: 0 } })
          .then(({ data }) => {
            setWhatsApps(data)
          })
      }
      fetchContacts();
      setLoading(false)
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [])

  useEffect(() => {
    setLoading(true)
    if (open === true) {
      openModal();
    }
  }, [open]);

  const clearErrors = () => {
    setDataItemError({
      name: false,
      flowId: false,
      whatsappId: false,
      phrase: false
    });
  };

  const clearData = () => {
    setFlowSelected();
    setDataItem({
      name: "",
      phrase: ""
    });
  };

  const applicationSaveAndEdit = () => {
    let error = 0;
    if (dataItem.name === "" || dataItem.name.length === 0) {
      setDataItemError(old => ({ ...old, name: true }));
      error++;
    }
    if (!flowSelected) {
      setDataItemError(old => ({ ...old, flowId: true }));
      error++;
    }
    if (dataItem.phrase === "" || dataItem.phrase.length === 0) {
      setDataItemError(old => ({ ...old, phrase: true }));
      error++;
    }
    if(!selectedWhatsapp){
      setDataItemError(old => ({ ...old, whatsappId: true }))
    }

    if (error !== 0) {
      return;
    }

    const idFlow = flowsDataComplete.filter(
      item => item.name === flowSelected
    )[0].id;

    const whatsappId = selectedWhatsapp !== "" ? selectedWhatsapp : null

    if (FlowCampaignId) {
      api.put("/flowcampaign", {
        id: FlowCampaignId,
        name: dataItem.name,
        flowId: idFlow,
        whatsappId: whatsappId,
        phrase: dataItem.phrase,
        status: active
      })
      onClose();
      onSave('ok');
      toast.success("Frase alterada com sucesso!");
      clearData();
    } else {
      api.post("/flowcampaign", {
        name: dataItem.name,
        flowId: idFlow,
        whatsappId: whatsappId,
        phrase: dataItem.phrase
      });
      onClose();
      onSave('ok');
      toast.success("Frase criada com sucesso!");
      clearData();
    }
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          style: {
            borderRadius: "20px",
          }
        }}
      >
        <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
          {campaignEditable ? (
            <>
              {FlowCampaignId
                ? `Editar Campanha`
                : `Nova Campanha`}
            </>
          ) : (
            <>{`${i18n.t("campaigns.dialog.readonly")}`}</>
          )}
        </DialogTitle>
        <DialogContent className={classes.dialogContent} dividers>
          {!loading && (
            <Stack spacing={3} sx={{ mt: 1 }}>
              <Stack spacing={1}>
                <Typography variant="subtitle2" style={{ fontWeight: 700, color: theme.palette.type === 'dark' ? "rgba(255,255,255,0.7)" : "#666" }}>
                  Nome da Campanha
                </Typography>
                <TextField
                  placeholder="Ex: Boas vindas vendas"
                  variant="outlined"
                  error={dataItemError.name}
                  defaultValue={dataItem.name}
                  onChange={e => {
                    setDataItem(old => ({ ...old, name: e.target.value }));
                  }}
                  className={classes.textField}
                  fullWidth
                />
              </Stack>

              <Stack spacing={1}>
                <Typography variant="subtitle2" style={{ fontWeight: 700, color: theme.palette.type === 'dark' ? "rgba(255,255,255,0.7)" : "#666" }}>
                  Fluxo de Automação
                </Typography>
                <Autocomplete
                  disablePortal
                  value={flowSelected}
                  options={flowsData}
                  onChange={(event, newValue) => {
                    setFlowSelected(newValue);
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      error={dataItemError.flowId}
                      variant="outlined"
                      placeholder="Selecione o fluxo que será disparado"
                      fullWidth
                    />
                  )}
                />
              </Stack>

              <Stack spacing={1}>
                <Typography variant="subtitle2" style={{ fontWeight: 700, color: theme.palette.type === 'dark' ? "rgba(255,255,255,0.7)" : "#666" }}>
                  Conexão (WhatsApp)
                </Typography>
                <Select
                  required
                  fullWidth
                  displayEmpty
                  variant="outlined"
                  value={selectedWhatsapp}
                  onChange={(e) => {
                    setSelectedWhatsapp(e.target.value)
                  }}
                  error={dataItemError.whatsappId}
                  renderValue={() => {
                    if (selectedWhatsapp === "") {
                      return <Typography color="textSecondary">Selecione uma Conexão</Typography>
                    }
                    const whatsapp = whatsApps.find(w => w.id === selectedWhatsapp)
                    return whatsapp?.name || "Conexão não encontrada"
                  }}
                >
                  {whatsApps?.length > 0 &&
                    whatsApps.map((whatsapp, key) => (
                      <MenuItem dense key={key} value={whatsapp.id}>
                        <ListItemText
                          primary={
                            <Box display="flex" alignItems="center">
                              <Typography variant="body2">{whatsapp.name}</Typography>
                              <Typography variant="caption" className={whatsapp.status === 'CONNECTED' ? classes.online : classes.offline}>
                                ({whatsapp.status})
                              </Typography>
                            </Box>
                          }
                        />
                      </MenuItem>
                    ))
                  }
                </Select>
              </Stack>

              <Stack spacing={1}>
                <Typography variant="subtitle2" style={{ fontWeight: 700, color: theme.palette.type === 'dark' ? "rgba(255,255,255,0.7)" : "#666" }}>
                  Palavra-chave Gatilho
                </Typography>
                <TextField
                  placeholder="Ex: #oferta"
                  variant="outlined"
                  error={dataItemError.phrase}
                  defaultValue={dataItem.phrase}
                  onChange={e => {
                    setDataItem(old => ({ ...old, phrase: e.target.value }));
                  }}
                  className={classes.textField}
                  fullWidth
                />
              </Stack>

              <Box display="flex" alignItems="center" gap={1}>
                <Checkbox 
                  checked={active} 
                  onChange={() => setActive(old => !old)} 
                  className={classes.checkbox} 
                />
                <Typography variant="body2" style={{ fontWeight: 600 }}>Campanha Ativa</Typography>
              </Box>
            </Stack>
          )}

          {loading && (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <CircularProgress color="primary" />
            </Box>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={() => {
              onClose();
              clearErrors();
            }}
            className={classes.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            className={classes.saveButton}
            onClick={() => applicationSaveAndEdit()}
            disabled={loading}
          >
            {FlowCampaignId ? "Salvar Alterações" : "Criar Campanha"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CampaignModalPhrase;